import { render, staticRenderFns } from "./ApplicationForReviewAppLeaveRefusedPg.vue?vue&type=template&id=1e464b2a&scoped=true"
import script from "./ApplicationForReviewAppLeaveRefusedPg.vue?vue&type=script&lang=ts"
export * from "./ApplicationForReviewAppLeaveRefusedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e464b2a",
  null
  
)

export default component.exports